import routerOptions0 from "/Users/macgitlabrunner1/builds/EFFy8Dyq/5/web-applications/revagency-com/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}